import type { CartPlatform } from '../../constants/cart-plaforms';
import type { CheckoutContext, CheckoutMixpanelEvents } from '../../types';
import { createCartItemsStore } from '../createCartItemsStore';
import { createOrderConfirmationStore } from '../createOrderConfirmationStore';
import { createUpsertOrderFromCartStore } from '../createUpsertOrderFromCartStore';
import type { EditionsRoutes } from '#lib/websites/editions/constants/routes.js';
import { createDialogStores } from '$global/components/Dialog';
import { createFormStore } from '$global/features/form/utils/createFormStore';

export interface CreateCheckoutContextArgs<T> {
	key: string;
	cartSuffix?: string;
	cartEntryClasses: CheckoutContext<EditionsRoutes>['cartEntryClasses'];
	mixpanelEvents: CheckoutMixpanelEvents;
	codeEnabled: boolean;
	platform: CartPlatform;
	checkoutRoute: T;
	orderConfirmedRoute: T;
	homeRoute: string;
	browseButtonRoute: string;
	browseButtonLabel: string;
	showZeroPence: boolean;
	getCartItemsFromOrder?: CheckoutContext<EditionsRoutes>['getCartItemsFromOrder'];
	createItemsQuery?: CheckoutContext<EditionsRoutes>['createItemsQuery'];
	createCartItemsQuery: CheckoutContext<EditionsRoutes>['createCartItemsQuery'];
}

export const createCheckoutContext = <T>({
	key,
	cartSuffix,
	cartEntryClasses,
	mixpanelEvents,
	codeEnabled,
	platform,
	checkoutRoute,
	homeRoute,
	showZeroPence,
	browseButtonRoute,
	browseButtonLabel,
	orderConfirmedRoute,
	getCartItemsFromOrder,
	createItemsQuery,
	createCartItemsQuery,
}: CreateCheckoutContextArgs<T>) => {
	const cartItemsStore = createCartItemsStore(
		cartSuffix ? `${key}-${cartSuffix}` : key
	);
	const cartDrawerStore = createDialogStores();
	const checkoutFormStore = createFormStore(key);
	const upsertOrderFromCartStore = createUpsertOrderFromCartStore();
	const orderConfirmationStore = createOrderConfirmationStore(key);

	return {
		key,
		cartEntryClasses,
		mixpanelEvents,
		codeEnabled,
		showZeroPence,
		cartItems: cartItemsStore,
		cartPlatform: platform,
		checkoutRoute,
		homeRoute,
		browseButtonRoute,
		browseButtonLabel,
		orderConfirmedRoute,
		cartDrawer: cartDrawerStore,
		checkoutForm: checkoutFormStore,
		upsertOrderFromCart: upsertOrderFromCartStore,
		orderConfirmation: orderConfirmationStore,
		getCartItemsFromOrder,
		createItemsQuery,
		createCartItemsQuery,
	};
};
